// @flow
import * as React from 'react';
import { CompactRow } from '../../layouts/compact_row';
import Divider from './divider';
import { Body, Link } from '../../typography';
import type { DataProvidesProps } from '../../utils/constants';
import { getDataProvidesProps } from '../../utils/constants';
import { BackLink, BackButton } from './back';

type ContainerProps = {
  children: React.Node,
};
const Container = (props: ContainerProps) => (
  <CompactRow divider={<Divider />}>{props.children}</CompactRow>
);

type CrumbProps = {
  label: string,
  href: string,
};

const Crumb = (props: CrumbProps) => (
  <Link href={props.href}>{props.label}</Link>
);

type CurrentProps = {
  label: string,
};
const Current = (props: CurrentProps) => (
  <Body aria-current="location">{props.label}</Body>
);

type BreadcrumbsProps = {
  /**
   * The route to the current page or element.
   */
  crumbs: Array<CrumbProps>,
  /**
   * The page or element that a user is viewing.
   */
  current: string,
  ...DataProvidesProps,
};

const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { crumbs, current } = props;

  return (
    <nav aria-label="breadcrumbs" {...getDataProvidesProps(props)}>
      <Container>
        {crumbs.map((crumbProps: CrumbProps) => (
          <Crumb key={crumbProps.label.toLowerCase()} {...crumbProps} />
        ))}
        <Current label={current} />
      </Container>
    </nav>
  );
};

Breadcrumbs.defaultProps = {
  'data-provides': 'breadcrumbs',
};

export { BackButton, BackLink, Breadcrumbs };

export default Breadcrumbs;
